import { render, staticRenderFns } from "./DualWaterDevicePanel.vue?vue&type=template&id=61d37d01&scoped=true&lang=pug&"
import script from "./DualWaterDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./DualWaterDevicePanel.vue?vue&type=script&lang=ts&"
import style0 from "./DualWaterDevicePanel.vue?vue&type=style&index=0&id=61d37d01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d37d01",
  null
  
)

export default component.exports